(function(angular) {
    'use strict';

    angular.module('mobilezuz').controller('InvalidCartItemsRemovalCtrl', InvalidCartItemsRemovalCtrl);

    InvalidCartItemsRemovalCtrl.$inject = ['$mdDialog', '$scope', 'invalidLines', 'Cart', 'DELIVERY_MODE_TOGGLE', 'Config', 'Util', '$filter','isShowLimitWarningMessage', 'overQuantityLines', '$state'];

    function InvalidCartItemsRemovalCtrl($mdDialog, $scope, invalidLines, Cart, DELIVERY_MODE_TOGGLE, Config, Util, $filter, isShowLimitWarningMessage, overQuantityLines, $state) {
        var invalidCartItemsRemovalCtrl = this,
        _translate = $filter('translate');

        invalidCartItemsRemovalCtrl.invalidLines = invalidLines || [];
        invalidCartItemsRemovalCtrl.isShowLimitWarningMessage = isShowLimitWarningMessage;
        invalidCartItemsRemovalCtrl.languageId =  Config.language.id;
        invalidCartItemsRemovalCtrl.itemLimitExceededWarning = {};
        invalidCartItemsRemovalCtrl.itemLimitExceededMessageAtCheckout = {};
        invalidCartItemsRemovalCtrl.totalCart = Cart.total.lines;
        invalidCartItemsRemovalCtrl.overQuantityLines = overQuantityLines || [];
        invalidCartItemsRemovalCtrl.deliveryType = localStorage.getItem('mobileZuzModeToggle') == DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP ? _translate('delivery_mode_2') : _translate('delivery_mode_1');

        Config.waitForInit().then(function () {
            if (Config.retailer.settings) {
                invalidCartItemsRemovalCtrl.itemLimitExceededWarning = Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededWarning || {};
                invalidCartItemsRemovalCtrl.itemLimitExceededMessageAtCheckout =  Util.tryParseJson(Config.retailer.settings.productLimitInCart) && Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededMessageAtCheckout || {};
            }
        });
        $scope.$watch(Config.language.id, function(newVal, oldVal) {
            if (newVal === oldVal) return;
            
            invalidCartItemsRemovalCtrl.deliveryType = localStorage.getItem('mobileZuzModeToggle') == DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP ? _translate('delivery_mode_2') : _translate('delivery_mode_1');
        });

        function _removeCartItems (invalidLines) {
            Cart.removeLines(invalidLines, true);
        }

        function _adjustLinesQuantityToLimit(overQuantityLines) {
            angular.forEach(overQuantityLines, function(line) {
                var quantityToMinus = line.quantity - line.overQuantityInfo.maxQuantity;
                for (var i = 0; i < quantityToMinus; i++) {
                    Cart.minusQuantity(line);
                }
            })
        }

        invalidCartItemsRemovalCtrl.replaceMessage = function () {
            var template = invalidCartItemsRemovalCtrl.itemLimitExceededMessageAtCheckout.popUpMessage[invalidCartItemsRemovalCtrl.languageId];
        
            if (!template) {
                return null;
            }
            
            var params = {
                '{Product Amount in the Cart}': invalidCartItemsRemovalCtrl.totalCart,
                '{Product Amount Limit}': invalidCartItemsRemovalCtrl.itemLimitExceededWarning.maxProduct || '',
                '{delivery type}': _translate('delivery_mode_' + DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP)
            };

            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var regex = new RegExp(key, 'g');
                    template = template.replace(regex, params[key]);
                }
            }
            return template;
        };

        invalidCartItemsRemovalCtrl.removeLinesAndSwitchToExpressDelivery = function() {
            _removeCartItems(invalidCartItemsRemovalCtrl.invalidLines);
            _adjustLinesQuantityToLimit(invalidCartItemsRemovalCtrl.overQuantityLines);

            // in case user add more product than limit redirect to cart page
            // so they can remove some products to be able to switch to express delivery
            if(invalidCartItemsRemovalCtrl.shouldShowExceedLimitWarning()) {
                $state.go('app.cart');
            }

            // send data back to parent controller
            $mdDialog.hide({isConfirmed: true});
        };

        invalidCartItemsRemovalCtrl.shouldShowLimitWarningMessage = function() { 
            return invalidCartItemsRemovalCtrl.totalCart > invalidCartItemsRemovalCtrl.itemLimitExceededWarning.maxProduct && invalidCartItemsRemovalCtrl.isShowLimitWarningMessage;
        }

        invalidCartItemsRemovalCtrl.stayWithScheduledDelivery = function() {
            localStorage.setItem('mobileZuzModeToggle', DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP);
            Config.setBranchArea(Config.branch.foundScheduledDeliveryOrPickupArea.id, Config.branch.foundScheduledDeliveryOrPickupArea.name, true);
            $mdDialog.hide({isConfirmed: false});
        };

        invalidCartItemsRemovalCtrl.shouldShowExceedLimitWarning = function() {
            return invalidCartItemsRemovalCtrl.totalCart > invalidCartItemsRemovalCtrl.itemLimitExceededWarning.maxProduct && invalidCartItemsRemovalCtrl.isShowLimitWarningMessage;
        };

        // invalidCartItemsRemovalCtrl.getProductUnitWithoutSoldBy  = Util.getProductUnitWithoutSoldBy; // will be implemented later
        invalidCartItemsRemovalCtrl.getProductUnit = Util.getProductUnit;

        invalidCartItemsRemovalCtrl.getConfirmButtonText = function() {
            var invalidLinesAndOverQuantityAndExceedLimit = invalidCartItemsRemovalCtrl.shouldShowExceedLimitWarning() && invalidCartItemsRemovalCtrl.overQuantityLines.length > 0 && invalidCartItemsRemovalCtrl.invalidLines.length > 0;
            var overQuantity = invalidCartItemsRemovalCtrl.overQuantityLines.length > 0;
            var exceedLimitAndOverQuantity = invalidCartItemsRemovalCtrl.shouldShowExceedLimitWarning() && invalidCartItemsRemovalCtrl.overQuantityLines.length > 0;
            
            if(invalidLinesAndOverQuantityAndExceedLimit || exceedLimitAndOverQuantity) {
                return _translate('remove_items_and_adjust_your_cart');
            } else if (overQuantity) {
                return _translate('confirm_and_switch_to_express_delivery');
            } else {
                return _translate('remove_items_and_switch_to_express_delivery');
            }
        }

        invalidCartItemsRemovalCtrl.getCartLinesOverQuantityAdjustSuggestionText = function(line) {
            return _translate('adjusted_quantity_{x}_instead_of_{y}').replace('{x}', line.overQuantityInfo.maxQuantity).replace('{y}', line.quantity);
        }
            
    }
})(angular);